import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResponseObject } from 'src/app/model/ResponseObject';
import { DropdownModal } from 'src/app/model/ComponentModels/dropdown-modal';
import { AppModel } from 'src/app/model/AppModel';
import { AsstntsrchServiceService } from 'src/app/services/AsstntsrchService';
import * as _ from 'lodash';
import { RadioModal } from 'src/app/model/ComponentModels/radio-modal';
import { AssistanceSearchInput } from 'src/app/model/EligibilityModels/AssistanceSearchInput';
import { ListOfValue } from 'src/app/model/EligibilityModels/ListOfValue';
import { RfrncDtItemsVO } from 'src/app/model/EligibilityModels/RfrncDtItemsVO';
import { AhctUtils } from 'src/app/core/services/AhctUtils';
import { AppRouteConstants } from 'src/app/core/constants/AppRouteConstants';
import { ApplnConstants } from 'src/app/core/constants/ApplnConstants';
import { RefConstants } from 'src/app/core/constants/RefConstants';
import { AHCTAPIServices } from 'src/app/services/ahCTAPIServices';
import { SharedService } from 'src/app/services/shared.service';
import { AuthorizationApiService } from 'src/app/services/authorization-api.service';
import { RoutingState } from 'src/app/core/services/routingState';
import { Router, ParamMap, ActivatedRoute } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-asstnt-srch',
  templateUrl: './asstnt-srch.component.html',
  styleUrls: ['./asstnt-srch.component.css']
})
export class AsstntSrchComponent implements OnInit {
  asstntSrchFrm: FormGroup;

  organizationName: string[];
  languagePreference: DropdownModal = new DropdownModal();
  townCity: string[];
  radius: string[];
  radioValuesList: Array<ListOfValue>;
  appModel: AppModel = new AppModel();
  radioMdl: RadioModal = new RadioModal();
  rfrncDtItemsVO: RfrncDtItemsVO = new RfrncDtItemsVO();
  rfrncDt: RfrncDtItemsVO = new RfrncDtItemsVO();
  response: ResponseObject = new ResponseObject();
  searchResult = [];
  needTypeCheck: string;
  assistanceSearchInput: AssistanceSearchInput = new AssistanceSearchInput();
  defOption: string;
  langCd: string = 'en';

  constructor(private formBuilder: FormBuilder,
              private asstntSrchService: AsstntsrchServiceService,
              private router: Router,
              private ahctUtils: AhctUtils,
              private apiService: AHCTAPIServices,
              private _authAPIService: AuthorizationApiService,
              private _sharedService : SharedService,
              private routingState: RoutingState,
              private route: ActivatedRoute,
              public translate: TranslateService) {
                //PT-18452 Start
                this.route.queryParams.subscribe((params: ParamMap) => {
                  if (params && params['langCd']) {
                    this.langCd = params['langCd'] || 'en';
                    console.log(this.langCd);
                    if (this.langCd != 'en') {
                      sessionStorage.setItem(ApplnConstants.USER_LANGUAGE, 'es');
                      this.translate.use('es');
                    } else {
                      sessionStorage.setItem(ApplnConstants.USER_LANGUAGE, 'en');
                      this.translate.use('en');
                    }
                  }
                });
                //PT-18452 End 
  }

  ngOnInit() {
    this.appModel = null;
   
    this._sharedService.publicNonEnrollFlow(false);
    this._sharedService.publicBrokerFlagChanges(true);
    this.asstntSrchService.getFieldDropdowns().subscribe(
      res => {
        const appModel: AppModel = _.clone(res);
        if (this.apiService.getUserLanguage() != null && this.apiService.getUserLanguage() === 'es') {
          appModel.rfrncDtItemsVO.radiusList.push('--Cualqueria--');
          this.defOption = '--Cualqueria--';
        } else {
          appModel.rfrncDtItemsVO.radiusList.push('--Any--');
          this.defOption = '--Any--';
        }
        this.organizationName = appModel.rfrncDtItemsVO.organizationNames;
        this.townCity = appModel.rfrncDtItemsVO.cities;
        this.radius = appModel.rfrncDtItemsVO.radiusList;
        this.rfrncDtItemsVO = appModel.rfrncDtItemsVO;
        this.radioMdl.options = this.rfrncDtItemsVO.radioValueList;
        this.radioValuesList = this.rfrncDtItemsVO.radioList;
      });
    const arry = [RefConstants.PrefLanguage];
    this.apiService.getRfrncDt(arry).subscribe(res => {
      this.rfrncDt = _.clone(res);
      this.languagePreference.options = this.rfrncDt.assisterLanguageList;
    });

    localStorage.removeItem(ApplnConstants.ASST_SEARCH_OBJECT);
    this.asstntSrchFrm = this.formBuilder.group({
      zipCode: [this.assistanceSearchInput != null ? this.assistanceSearchInput.zipCode : ''],
      radius: [this.assistanceSearchInput != null ? this.assistanceSearchInput.radius : ''],
      lastName: [this.assistanceSearchInput != null ? this.assistanceSearchInput.lastName : ''],
      organizationName: [this.assistanceSearchInput != null ? this.assistanceSearchInput.organizationName : ''],
      languagePreference: [this.assistanceSearchInput != null && this.assistanceSearchInput.languagePreference
        ? this.assistanceSearchInput.languagePreference : ''],
      townCity: [this.assistanceSearchInput != null ? this.assistanceSearchInput.townCity : ''],
      acceptNewCustomers: [this.assistanceSearchInput != null ? this.assistanceSearchInput.acceptNewCustomers : ''],
      provideAssistSEP: [this.assistanceSearchInput != null ? this.assistanceSearchInput.provideAssistSEP : ''],
      needType: [this.assistanceSearchInput != null ? this.assistanceSearchInput.needType : '']
    });
    const pref = this.asstntSrchFrm.controls.languagePreference.value;
    if (!pref) {
      this.asstntSrchFrm.controls.languagePreference.setValue('');
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkMaxLength(event, maxChar) {
    return this.numberOnly(event) && this.ahctUtils.restrictMaxlength(event, maxChar);
  }

  validateNeedType() {
    if (this.asstntSrchFrm.controls.needType.value == null || this.asstntSrchFrm.controls.needType.value === '') {
      this.needTypeCheck = 'Y';
    } else if (this.asstntSrchFrm.controls.needType.value != null) {
      this.needTypeCheck = 'N';
    }
  }

  validateData() {
    let checkValue = false;
    if (this.asstntSrchFrm.controls.needType.value == null
       || this.asstntSrchFrm.controls.needType.value === '') {
      this.needTypeCheck = 'Y';
      checkValue = true;
    }
    return checkValue;
  }

  ngOnDestroy() {
    this._sharedService.publicBrokerFlagChanges(false);
    this._sharedService.publicNonEnrollFlow(true);
  }

  backButtonAction() {
    let userRole: string = null;
    if (this._authAPIService.isUserLoggedIn()) {

     this._authAPIService.getCSRFToken().subscribe(csrfResp  => {
      this._authAPIService.getLoggedinUserRole().subscribe(resp => {
        const userRoleType: string[] = _.clone(resp);
        if (null != userRoleType && userRoleType.length > 0) {
          userRole = userRoleType[0];
          this._authAPIService.setUserRole(userRole);
          if ('ROLE_HIX_Individual' == userRole || 'Individual' == userRole) {
            ApplnConstants.LOG_ON_ACCOUNT_TYPE = 'accountHome';
            this.router.navigateByUrl('/' + AppRouteConstants.CNSMR_STTNG
              + '/' + AppRouteConstants.INDV_DSHBRD);
          } else if ('ROLE_HIX_Broker' == userRole) {
            ApplnConstants.LOG_ON_ACCOUNT_TYPE = 'Assister';
            this.router.navigateByUrl('/' + AppRouteConstants.MAIN_PRFX_MDUL
              + '/' + AppRouteConstants.ASST_DSHBRD);
          } else {
            this.router.navigateByUrl('/home');
          }
        } else {
          this.apiService.gNavigationFlag = true;
          window.history.back();
        }

      });
    });

    } else {
      this.apiService.gNavigationFlag = true;
      window.history.back();
    }
      
      

      
  }
  submitHandler() {
    if (!this.validateData()) {
      if (this.asstntSrchFrm.controls.acceptNewCustomers.value) {
        this.asstntSrchFrm.controls.acceptNewCustomers.patchValue('Y');
      }
      if (this.asstntSrchFrm.controls.acceptNewCustomers.value === false) {
        this.asstntSrchFrm.controls.acceptNewCustomers.patchValue(null);
      }

      if (this.asstntSrchFrm.controls.provideAssistSEP.value) {
        this.asstntSrchFrm.controls.provideAssistSEP.patchValue('Y');
      }
      if (this.asstntSrchFrm.controls.provideAssistSEP.value === false) {
        this.asstntSrchFrm.controls.provideAssistSEP.patchValue(null);
      }
      if (this.asstntSrchFrm.controls.radius.value == null || this.asstntSrchFrm.controls.radius.value === 0) {
        this.asstntSrchFrm.controls.radius.patchValue(5);
      }
      const assistanceSearchInput: AssistanceSearchInput = Object.assign({}, this.asstntSrchFrm.value);
      this.asstntSrchService.setApplnObjInSession(assistanceSearchInput);
      this.router.navigateByUrl('/' + AppRouteConstants.AST_SRCH_PRFX_MDUL + '/' + AppRouteConstants.ASST_SEARCH_RESULTS);
    }
  }

  nameFieldValid($event, charLength) {
    const lengthCheck: boolean = this.ahctUtils.restrictMaxlength($event, charLength);
    if (lengthCheck) {
      return this.ahctUtils.nameFieldValid($event);
    } else {
      return lengthCheck;
    }
  }
}
